import { HomeService } from '../_services/home.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot , Router, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({providedIn: 'root'})
export class ActiveGuard implements CanActivate {

  error = '';
  constructor(private router: Router, private homeService: HomeService) {

}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable <boolean>  | Promise<boolean> | boolean | UrlTree {
    return this.homeService.isactive(route.params.shortname).then( (data: boolean) => {
      if (data) {
        return true;
      }
   
      else{
        if(state.url.includes("/survey")){
            return true;
          }
      this.router.navigate(['/' + route.params.shortname + '/error']);
      return false;
      }
     
    });
  
  }
  }
